/* ================================================================
   Weinkarte — gemeinsame Regeln für sichtbare Angaben.

   Der Server baut dieselbe Struktur für die öffentliche Ansicht.
   Hier entsteht sie zusätzlich lokal, damit sich eine Weinkarte auch
   ohne bestehende Freigabe drucken bzw. als PDF sichern lässt.
   ================================================================ */

const FELDER_VORGABE = {
  typ: true, winzer: true, region: true, land: false,
  jahr: true, bestand: false, notiz: true, preis: true,
  rebsorten: false, alkohol: false, restzucker: false, saeure: false,
  label: false, beschreibung: false, kritiken: false, etikett: false, wetter: false,
};

/* Beschriftungen für die Einstellungsliste im Editor. */
const FELDER_LABEL = {
  typ: "Farbe / Typ",
  winzer: "Winzer",
  region: "Region",
  land: "Land",
  jahr: "Jahrgang",
  bestand: "Menge auf der Karte",
  notiz: "Notiz",
  preis: "Preis",
  rebsorten: "Rebsorten",
  label: "Label",
  alkohol: "Alkohol",
  restzucker: "Restzucker",
  saeure: "Säure",
  beschreibung: "Beschreibungen",
  kritiken: "Kritiken",
  etikett: "Etikettenfotos",
  wetter: "Witterung des Jahrgangs",
};

function felderVon(karte) {
  const f = (karte && karte.felder) || {};
  /* Ältere Karten kannten nur ein gemeinsames Feld „analytik“ —
     dessen Wert gilt als Vorgabe für die drei Einzelfelder. */
  const analytikAlt = typeof f.analytik === "boolean" ? f.analytik : null;
  const out = {};
  for (const k of Object.keys(FELDER_VORGABE)) {
    if (typeof f[k] === "boolean") out[k] = f[k];
    else if (analytikAlt != null && (k === "alkohol" || k === "restzucker" || k === "saeure")) out[k] = analytikAlt;
    else out[k] = FELDER_VORGABE[k];
  }
  return out;
}

const flaschenSumme = (jg) =>
  Object.values((jg && jg.bestaende) || {}).reduce((s, n) => s + (Number(n) || 0), 0);

/* Rebsortennamen eines Weins — neue Listenform oder Altbestand. */
function rebsortenNamenVon(w) {
  if (Array.isArray(w.rebsortenListe)) return w.rebsortenListe.map((r) => r && r.name).filter(Boolean);
  if (Array.isArray(w.rebsorten)) return w.rebsorten.filter(Boolean);
  return String(w.rebsorten || "").split(",").map((t) => t.trim()).filter(Boolean);
}

/* Erzeugt aus dem Kellerbuch dieselbe Form, die /api/geteilt liefert. */
function karteAufbereiten(db, karte) {
  const felder = felderVon(karte);
  const weinById = new Map((db.weine || []).map((w) => [w.id, w]));
  const winzerById = new Map((db.winzer || []).map((w) => [w.id, w]));
  const regionById = new Map((db.regions || []).map((r) => [r.id, r]));
  const eintraege = [];
  for (const e of karte.eintraege || []) {
    const w = weinById.get(e.weinId);
    if (!w) continue;
    const wz = w.winzerId ? winzerById.get(w.winzerId) : null;
    const reg = (w.regionId && regionById.get(w.regionId)) || (wz && regionById.get(wz.regionId)) || null;
    let jahr = null, jg = null;
    if (e.jgId) {
      jg = (w.jahrgaenge || []).find((j) => j.id === e.jgId) || null;
      if (jg) jahr = jg.jahr;
    }
    /* Gezeigt wird, was auf der Karte steht — nicht der Kellerbestand. */
    const bestand = e.menge != null ? e.menge : null;
    eintraege.push({
      name: w.name,
      typ: felder.typ ? (w.typ || null) : null,
      winzer: felder.winzer && wz ? wz.name : "",
      region: felder.region && reg ? reg.name : "",
      land: felder.land && reg ? (reg.land || "") : "",
      jahr: felder.jahr ? jahr : null,
      groesse: e.groesse || null,
      bestand: felder.bestand ? bestand : null,
      preis: felder.preis && typeof e.preis === "number" ? e.preis : null,
      notiz: felder.notiz ? (e.notiz || "") : "",
      rebsorten: felder.rebsorten ? rebsortenNamenVon(w) : [],
      label: felder.label ? (w.label || "") : "",
      alkohol: felder.alkohol && jg && jg.alkohol != null ? jg.alkohol : null,
      restzucker: felder.restzucker && jg && jg.restzucker != null ? jg.restzucker : null,
      saeure: felder.saeure && jg && jg.saeure != null ? jg.saeure : null,
      /* Für die feste Gliederung des PDFs — unabhängig davon, was
         auf der Karte sichtbar ist, bleibt die Reihenfolge stabil. */
      sortLabel: w.label || "",
      sortLand: reg ? (reg.land || "") : "",
      sortRegion: reg ? reg.name : "",
      sortWinzer: wz ? wz.name : "",
    });
  }
  return { titel: karte.titel || "Weinkarte", felder, eintraege };
}

export { FELDER_VORGABE, FELDER_LABEL, felderVon, karteAufbereiten, rebsortenNamenVon };
